module.exports = __webpack_public_path__ + "static/media/table.bf7905ad.svg";